<template>
  <BlockLoading v-if="isLoadingSiteKey" class="mx-auto p-2" />
  <GuAlert v-else-if="hasErrorLoadingSiteKey" variant="danger" icon="bxs-error">
    <p>Error loading the site key for the CAPTCHA</p>
  </GuAlert>
  <template v-else>
    <div class="g-recaptcha mx-auto" :data-sitekey="siteKey" data-callback="onCaptchaVerify" />
    <input
      id="captchaResponse"
      type="hidden"
      name="captchaResponse"
      value=""
    >
  </template>
</template>

<script setup>
import { watch } from 'vue'
import { useScriptTag } from '@vueuse/core'

import { getIntegrationSetting } from '@shared/api/systemData.api'
import BlockLoading from '@shared/components/BlockLoading.vue'
import GuAlert from '@shared/gu-components/alert/GuAlert.vue'

// integration settings for captcha
const GROUP = 'Authentication'
const KEY = 'captchaPublicKey'

const {
  data: siteKey,
  isError: hasErrorLoadingSiteKey,
  isPending: isLoadingSiteKey,
} = getIntegrationSetting(GROUP, KEY)

watch(siteKey, () => {
  useScriptTag(
    'https://www.google.com/recaptcha/api.js',
    () => {},
  )
})

window.onCaptchaVerify = function (response) {
  document.getElementById('captchaResponse').value = response
}
</script>
